<template>
    <div class="invite-container">
        <!-- 门店注册二维码区域 -->
        <div class="qrcode-section">
            <!-- 顶部标签区域 -->
            <div class="top-section">
                <span class="store-name">{{DepartmentData.department_name}}-{{DepartmentData.position_name}}-门店注册邀请码</span>
                <span class="new-customer-tag">新客户推荐</span>
            </div>
            <!-- 说明文字 -->
            <div class="description">客户已添加企微但未注册进店，扫码进店</div>
            <div class="qrcode-placeholder">
                <!-- 二维码占位 -->
                <div class="qrcode-img">
                    <img :src="ShopQrcodeUrl" alt="门店注册二维码">
                </div>
            </div>
            <!-- <div class="validity">有效期：2026-09-14 16:00:00</div> -->
            <div class="share-button store-share" @click="toggleDialog(1)">分享门店邀请码</div>
        </div>

        <!-- 企微邀请码区域 -->
        <div class="qrcode-section">
            <div class="wecom-header">
                <span class="wecom-title">{{DepartmentData.department_name}}-{{DepartmentData.position_name}}-企微邀请码</span>
                <img :src="wecomIco" alt="企微图标" class="wecom-icon">
            </div>
            <div class="description">新客户扫码添加企微，点击消息链接注册进店</div>
            <div class="qrcode-placeholder">
                <!-- 二维码占位 -->
                <div class="qrcode-img">
                    <img :src="WecomQrcodeUrl" alt="企微二维码">
                </div>
            </div>
            <div class="share-button wecom-share" @click="toggleDialog(2)">分享企微邀请码</div>
        </div>
    </div>
    <!-- 点击分享出现的弹框 -->
    <div class="invite-dialog" v-if="showDialog" @touchstart="startPress" @touchend="endPress"
        @touchcancel="cancelPress" @mousedown="startPress" @mouseup="endPress" @mouseleave="cancelPress">
        <div class="dialog-content">
            <div class="close-button" @click="toggleDialog(3)">
                <img :src="closeIco" alt="关闭">
            </div>
            <div class="dialog-header">
                <span v-if="dialogType === 1">{{DepartmentData.position_name}}邀请您进店</span>
                <span v-else>{{DepartmentData.position_name}}邀请您添加企微</span>
            </div>
            <div class="dialog-body">
                <span v-if="dialogType === 1">加入门店，解锁更多惊喜福利～</span>
                <span v-else>扫码添加企业微信，随后点击他的消息注册进店</span>
            </div>
            <div class="dialog-footer">
                <div class="dialog-footer-img">
                    <img :src="ShareQrcodeUrl" alt="">
                </div>
            </div>
            <div class="dialog-footer-text">
                <span class="store-name">门店名称：{{DepartmentData.department_name}}</span>
                <!-- <span class="validity-shop" v-if="dialogType === 1">有效期：2026-09-14 16:00:00</span>
                <span class="validity" v-else>有效期：2026-09-14 16:00:00</span> -->
            </div>
            <div class="footer-text">长按页面保存图片</div>
        </div>
    </div>

    <!-- 已使用vant的Toast组件 -->
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import html2canvas from 'html2canvas'
import { showToast, closeToast } from 'vant'
import auth from '@/utils/api/auth'

const showDialog = ref(false)
let dialogType = ref(0)
import wecomIco from '@/assets/img/icons/wecom-ico.png'
import closeIco from '@/assets/img/icons/close.png'
const ShopQrcodeUrl = ref()//门店注册邀请码
const WecomQrcodeUrl = ref()//企微邀请码
const ShareQrcodeUrl = ref('')//分享二维码
const DepartmentData = JSON.parse(localStorage.getItem('departmentdata'))

onMounted(() => {
   shopClerkWeComQRCode()
   addUserCode()
})
const shopClerkWeComQRCode = async ()=>{
    const res = await auth.shopClerkWeComQRCode({
        department_uuid: DepartmentData.department_uuid,
    })
    if(res.code === 200){
        WecomQrcodeUrl.value = res.data
    }
}
const addUserCode = async ()=>{
    const res = await auth.addUserCode({
        shop_uuid: DepartmentData.department_uuid,
        shop_tag_uuids: [],
    })
    if(res.code === 200){
        ShopQrcodeUrl.value = res.data
    }
}
// 长按相关变量
let pressTimer = null
const longPressDelay = 500 // 长按触发时间(毫秒)
const toggleDialog = (val) => {
    if (val === 3) {
        showDialog.value = false
        return
    }
    showDialog.value = true
    dialogType.value = val
    if (val === 1) {
        // 门店邀请码
        ShareQrcodeUrl.value = ShopQrcodeUrl.value
    } else if (val === 2) {
        // 企微邀请码
        ShareQrcodeUrl.value = WecomQrcodeUrl.value
    }
}

// 长按开始
const startPress = () => {
    pressTimer = setTimeout(() => {
        showToast({
            message: '正在保存图片...',
            duration: 0, // 不自动关闭
            overlay: false
        })
        // 触发保存图片功能
        saveDialogAsImage()
    }, longPressDelay)
}

// 长按结束
const endPress = () => {
    if (pressTimer) {
        clearTimeout(pressTimer)
        pressTimer = null
    }
}

// 长按取消
const cancelPress = () => {
    endPress()
}
// 将dialog区域转换为图片并保存
const saveDialogAsImage = async () => {
    try {
        // 获取dialog内容元素
        const dialogElement = document.querySelector('.dialog-content')
        if (!dialogElement) {
            console.error('未找到dialog内容元素')
            return
        }
        // 使用html2canvas将元素转换为canvas
        const canvas = await html2canvas(dialogElement, {
            backgroundColor: '#ffffff',
            scale: 2, // 提高图片质量
            useCORS: true, // 允许跨域图片
            logging: false
        })

        // 获取图片数据URL
        const imageDataUrl = canvas.toDataURL('image/png')
        // 保存图片到本地
        // downloadImage(imageDataUrl, '邀请码.png')

    } catch (error) {
        console.error('转换图片失败:', error)
    }
}


</script>

<style lang="less" scoped>
.invite-container {
    background-color: #F5F7FA;
    min-height: 100vh;
    padding: 10px 17px;

    .qrcode-section {
        background-color: white;
        border-radius: 8px;
        padding: 17px 14px;
        margin-bottom: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        .top-section {
            display: flex;
            align-items: center;
            margin-bottom: 3px;

            .store-name {
                color: #333333;
                font-size: 15px;
                margin-right: 23px;
                font-weight: 500;
                font-family: 'PingFang SC-Semibold';
            }

            .new-customer-tag {
                width: 77px;
                height: 26px;
                background: rgba(255, 113, 35, 0.1);
                border-radius: 4px;
                border: 1px solid #FF7123;
                color: #FF7123;
                font-size: 12px;
                font-weight: 500;
                font-family: 'PingFang SC-Medium';
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .description {
            color: #333;
            font-size: 13px;
            font-weight: 400;
            font-family: 'PingFang SC-Regular';
        }

        .wecom-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .wecom-title {
                color: #333333;
                font-size: 16px;
                font-weight: 500;
            }

            .wecom-icon {
                width: 24px;
                height: 24px;
            }
        }

        .qrcode-placeholder {
            border-top: 1px solid #E8E8E8;
            padding-top: 13px;
            display: flex;
            justify-content: center;
            margin-top: 13px;

            .qrcode-img {
                width: 122px;
                height: 122px;
                background-color: #E8E8E8;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #999999;
                font-size: 14px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .validity {
            text-align: center;
            color: #333;
            font-size: 13px;
        }

        .share-button {
            width: 100%;
            height: 46px;
            border: none;
            border-radius: 11px;
            font-size: 19px;
            font-weight: 500;
            cursor: pointer;
            transition: opacity 0.3s;
            font-family: 'PingFang SC-Medium';
            text-align: center;
            line-height: 46px;
            margin-top: 19px;

            &.store-share {
                background-color: #DCBB89;
                color: white;
            }

            &.wecom-share {
                background-color: #2D9EFC;
                color: white;
            }
        }
    }
}

.invite-dialog {
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    height: 100%;
    width: 100%;
    z-index: 999;

    .dialog-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        background-color: white;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .close-button {
            position: absolute;
            top: -33px;
            right: -12px;
            width: 24px;
            height: 24px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .dialog-header {
            text-align: center;
            margin-bottom: 6px;
            color: #333333;
            font-size: 19px;
            font-weight: 500;
        }

        .dialog-body {
            text-align: left;
            margin-bottom: 10px;
            color: #666;
            font-size: 15px;
            font-weight: 400;
        }

        .dialog-footer {
            display: flex;
            justify-content: center;

            .dialog-footer-img {
                width: 122px;
                height: 122px;
                background-color: #E8E8E8;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #999999;
                font-size: 14px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .dialog-footer-text {
            color: #333333;
            font-size: 15px;
            font-weight: 400;
            text-align: center;
            margin-top: 10px;
            font-family: 'PingFang SC-Regular';

            .store-name {
                font-weight: 500;
                display: block;
                color: #333333;
            }

            .validity {
                display: block;
                color: #2D9EFC;
            }

            .validity-shop {
                display: block;
                color: #FF7123;
            }
        }

        .footer-text {
            color: #e8e8e8;
            font-size: 13px;
            font-weight: 400;
            font-family: 'PingFang SC-Regular';
            text-align: center;
            position: absolute;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}

// 原来的提示样式已移至Toast组件中</style>